/**
 * Valid resource types
 */
export enum ResourceType {
  FILE = 'file',
  LINK = 'link',
  VIDEO = 'video',
  DOCUMENT = 'document',
  IMAGE = 'image',
  AUDIO = 'audio',
  EMBED = 'embed',
}

/**
 * Metadata structure for file resources
 */
export interface FileResourceMetadata {
  filename: string
  originalName?: string
  size?: number
  mimeType?: string
  uploadedAt?: string
  uploadedBy?: string
}

/**
 * Metadata structure for link resources
 */
export interface LinkResourceMetadata {
  domain?: string
  previewImage?: string
  title?: string
  description?: string
}

/**
 * Metadata structure for video resources
 */
export interface VideoResourceMetadata {
  platform?: 'youtube' | 'vimeo' | 'dailymotion' | 'other'
  videoId?: string
  duration?: number
  thumbnail?: string
  thumbnailUrl?: string
}

/**
 * Union type for all resource metadata
 */
export type ResourceMetadata =
  | FileResourceMetadata
  | LinkResourceMetadata
  | VideoResourceMetadata
  | Record<string, unknown>

/**
 * Settings for resource visibility and access control
 */
export interface ResourceSettings {
  isPublic?: boolean
  allowDownload?: boolean
  requiredRole?: string
  expiresAt?: string
}
